import React, { Component } from 'react'
import axios from 'axios'

//Message Box
import Message from '../Message'

//Loader
import Loader from '../Loader'

class SuggestionsForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      nofication: null,
      showNotification: false,
      data: {
        type: 'Suggestions',
        title:'Suggestions',
        firstname: '',
        lastname: '',
        phone: '',
        email: '',
        message: '',
      },
      loading: false,
      formIsValid: false,
      resText: '',
      sent: false,
      error: false,
      language: {
        la: 'es',
        firstname: 'First name:',
        lastname: 'Last name:',
        phone: 'Phone:',
        email: 'E-mail:',
        suggestion: 'Suggestion:',
        button: 'Send',
        notificationErr: 'The suggestion could not be sent. Please try later.',
        noficationSend: 'Thanks your suggestion has been sent.',
        sending: 'Sending...',
      },
    }
    this.handleHighlightEmptyValues = this.handleHighlightEmptyValues.bind(this)
  }

  handleChange = event => {
    const state = this.state.data
    state[event.target.name] = event.target.value
    this.setState(state)
  }

  handleHighlightEmptyValues = value => {
    if (this.state.emptyValues && _.isEmpty(value)) {
      return 'inputNormal inputError'
    }
    return 'inputNormal'
  }

  hasEmptyValue() {
    const { type, firstname, lastname, phone, email, message } = this.state.data
    const emptyValues = _.some(
      [type, firstname, lastname, phone, email, message],
      value => value === ''
    )
    if (emptyValues) {
      return true
    }
    return false
  }

  handleSubmit = event => {
    event.preventDefault()

    if (this.hasEmptyValue()) {
      this.setState({
        emptyValues: true,
        resText:
          'There are errors in the form. Please correct them and resubmit the form.',
      })
    } else {
      this.setState({ emptyValues: false, loading: true })
      axios({
        method: 'post',
        data: this.state.data,
        url: 'https://bkndNicaragua.miweb.cr:5004/api/contactForms/add',
      })
        .then(res => {
          console.log(res)
          this.setState({
            loading: false,
            sent: true,
            resText: 'Thank you. Your information has been sent',
          })
        })
        .catch(err => {
          this.setState({
            loading: false,
            error: true,
            resText:
              'Sorry we could not send your information. Please try later',
          })
          console.log(err)
        })
    }
  }

  render() {
    if (this.props.lan === 'es') {
      this.state.language = {
        la: 'es',
        firstname: 'Nombre:',
        lastname: 'Apellidos:',
        phone: 'Teléfono:',
        email: 'E-mail:',
        suggestion: 'Sugerencia:',
        button: 'Enviar',
        notificationErr:
          'La sugerencia no pudo ser enviada. Por favor intente mas tarde.',
        noficationSend: 'Gracias, tu sugerencia ha sido enviada.',
        sending: 'Enviado...',
      }
    }

    let respondField = null

    if (this.state.loading) {
      respondField = <Loader />
    }
    if (this.state.sent || this.state.error || this.state.emptyValues) {
      respondField = <Message text={this.state.resText} />
    }

    return (
      <form className="ContactFrom" onSubmit={this.handleSubmit}>
        <div className="firstBlock">
          <div>
            <label htmlFor="firstname">{this.state.language.firstname}</label>
            <input
              type="text"
              name="firstname"
              onChange={this.handleChange}
              className={this.handleHighlightEmptyValues(this.state.firstname)}
            />
          </div>
          <div>
            <label htmlFor="lastname">{this.state.language.lastname}</label>
            <input
              type="text"
              name="lastname"
              onChange={this.handleChange}
              className={this.handleHighlightEmptyValues(this.state.lastname)}
            />
          </div>
          <div>
            <label htmlFor="phone">{this.state.language.phone}</label>
            <input
              type="text"
              name="phone"
              onChange={this.handleChange}
              className={this.handleHighlightEmptyValues(this.state.phone)}
            />
          </div>
          <div>
            <label htmlFor="email">{this.state.language.email}</label>
            <input
              type="email"
              name="email"
              onChange={this.handleChange}
              className={this.handleHighlightEmptyValues(this.state.email)}
            />
          </div>
        </div>
        <div className="secondBlock">
          <div>
            <label htmlFor="message">{this.state.language.suggestion}</label>
            <textarea
              type="email"
              name="message"
              onChange={this.handleChange}
              className={this.handleHighlightEmptyValues(this.state.message)}
            />
          </div>
        </div>
        {respondField}
        <div>
          <button className="btn">{this.state.language.button}</button>
        </div>
      </form>
    )
  }
}
export default SuggestionsForm



// WEBPACK FOOTER //
// ./src/components/SuggestionsForm/index.js